import React from 'react';
import { View, TextInput, StyleProp, TextStyle } from 'react-native';
import { MaterialIcons  } from '@expo/vector-icons';
import {FontInfo, ReturnTypes } from '../~Utilities/Constants';
import Utilities from '../~Utilities/Utilities';
import { ConnectionOrd } from '../~Utilities/Connection';

/*   ---------------------------------------------------------------------   */

interface ITextInputEx
{
getstyle              : () => StyleProp<TextStyle>;
placeholder?          : string;
placeholderTextColor? : any;
spellCheck?       : boolean;
autoCorrect?      : boolean;
autoFocus?        : boolean;
autoCompleteType? : any;
secureTextEntry?  : boolean;
onChangeText?     : (a : string) => void;
onSubmitEditing   : () => void;
initValue?        : string;
hideErrorIcon?    : boolean;
}

/*   ---------------------------------------------------------------------   */

export default class TextInputEx extends React.Component<ITextInputEx>
 {
   private oTextInputRef : TextInput | null = null;
   private bInit         = false;

   //static  iInstance     = 0;

   /*   -------------------------------------------------------------------   */

   UpdateError(iError : number,
               sToken : string = "")
   {
   if (iError == ReturnTypes.WAITING)
      {
      //alert('waiting');
      return;   
      }

   if (!this.state.text)
      return;

   //console.log("invalid symbol2..." + newVal);
   //alert("inside txt input new: " + iError + " old: " + this.state.error);

   if (this.state.error != iError)
      {
      //this.state.error = iError;
      this.setState({error:iError, error_token:sToken});

      //this.forceUpdate();
      //alert("force update : " + this.state.error + " = " + iError);
      
      }
   }

   /*   ---------------------------------------------------------------------   */

   GetText()
   {
   return(this.state.text);
   }

   /*   ---------------------------------------------------------------------   */

   SetFocus()
   {
   this.oTextInputRef?.focus();
   }

   /*   ---------------------------------------------------------------------   */

   UpdateData(text)
   {
      if (this.state.text != text)
      {
      this.setState({text:text, error:ReturnTypes.OK, error_token:"",});
      //alert("changed text");
      //this.forceUpdate();
      }
   }

   /*   ---------------------------------------------------------------------   */
   
    constructor(props)
    {
    super(props);

    //this.oTextInputRef   = React.createRef();
    this.UpdateData      = this.UpdateData.bind(this);
    this.UpdateError     = this.UpdateError.bind(this);
    this.GetText         = this.GetText.bind(this);
    this.SetFocus        = this.SetFocus.bind(this);
    this.bInit           = false;

    if (this.props.initValue)
      {
      this.state = {text:this.props.initValue, error:ReturnTypes.OK, error_token:"",};
      Utilities.Sendlog("Text ctr : " + this.props.initValue);
      }
    else
      this.state = {text:"", error:ReturnTypes.OK, error_token:"",};

    //Utilities.Sendlog("Text ctr")
    //TextInputEx.iInstance++;
    }

    /*   ---------------------------------------------------------------------   */

    componentDidMount() 
    {
    //console.log("Text3 mount...");
    //this.props.onBindTxtEvent(this.UpdateError1, this.getText1, this.TextInputRef);
    }

    componentWillUnmount() 
    {
      //console.log("Text3 un-mount...");
      //this.props.bbb(this.UpdateData1, false);
    //this.props.onBindTxtEvent(null, null, null);
    }

   /*   ---------------------------------------------------------------------   */ 
   
    componentDidUpdate()
    {
      //alert(TextInputEx.iInstance);

      if (this.state.text == "init" && this.bInit == false)
         {
         Utilities.Sendlog("Text reset : " + this.props.initValue);            
         this.bInit = true;

         this.setState({text:"", error:ReturnTypes.OK, error_token:"",});
         //this.UpdateData("");
         }
    }

   /*   ---------------------------------------------------------------------   */ 

   state = {
      text: "",
      error:ReturnTypes.OK,
      error_token:"",
   }

   /*   ---------------------------------------------------------------------   */

   render() 
     {
      return (
       <View style={{alignSelf:'center', backgroundColor:'transparent', flexDirection:'row'}}>
       <TextInput
       style={this.props.getstyle()}
       placeholder={this.props.placeholder}
       ref={(ref) => { this.oTextInputRef = ref; }}
       placeholderTextColor={this.props.placeholderTextColor}

      autoFocus={this.props.autoFocus}

       spellCheck={this.props.spellCheck}
       autoCorrect={this.props.autoCorrect}
       autoCompleteType={this.props.autoCompleteType}

       secureTextEntry={this.props.secureTextEntry}

       //keyboardType={'ascii-capable'}

       value={this.state.text}
       onChangeText={text=>{this.UpdateData(text); if (this.props.onChangeText) this.props.onChangeText(text);}}
       onSubmitEditing={ ()=>{ this.props.onSubmitEditing()}}
       />
       <View style={this.state.error != ReturnTypes.ERR_INVALID || this.props.hideErrorIcon? {display:'none'} :
                    {alignItems:'center', justifyContent:'center', backgroundColor:'transparent', position:'absolute', right:19, bottom:10}}>
                       {/* <Text style={{color:'red', backgroundColor:'black', minwidth:40}}>{instance + "-" + this.state.error}</Text> */}
         <MaterialIcons name="error" size={24} color="red" />
       </View>

       <View style={this.state.error != ReturnTypes.ERR_DUPLICATE? {display:'none'} :
                    {alignItems:'center', justifyContent:'center', backgroundColor:'transparent', position:'absolute', right:19, bottom:10}}>
                       {/* <Text style={{color:'red', backgroundColor:'black', minwidth:40}}>{instance + "-" + this.state.error}</Text> */}
         <MaterialIcons name="assignment-turned-in" style={{}} size={24} color={FontInfo.sGreen} onPress={()=>{ if (this.state.error_token) ConnectionOrd.NavigateToToken(this.state.error_token)}} />
       </View>
       </View>  
      );
   }
}